<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      :close-on-click-modal="false"
      :before-close="resetValidation('user')"
      @close="close()"
      @open="open()"
    >
      <div>
        <el-upload
          class="avatar-uploader"
          :action="adminUrl + 'user/image/upload/' + user.id"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          name="image"
          :headers="image.headers"
          :on-error="handleAvatarError"
        >
          <img
            v-if="user.image_url"
            :src="user.image_url"
            class="user-avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <i v-if="user.image_url" @click="deleteCreatorImage" class="el-icon-error avatar-delete-icon"></i>
        </el-upload>
      </div>
      <el-form ref="user" id="user-form" :model="user" label-position="top">
        <el-form-item
          label="Email"
          ref="email"
          prop="email"
          :rules="[{ required: true, message: 'email is required' }]"
          :error="validation['email']"
        >
          <el-input type="text" v-model="user.email" clearable />
        </el-form-item>
        <el-form-item label="Featured" ref="featured" prop="featured" v-if="creator" >
          <el-switch v-model="user.featured"></el-switch>
        </el-form-item>
        <el-form-item label="Leaderboard" ref="leaderboard" prop="leaderboard" v-if="creator || company_user">
          <el-switch v-model="user.leaderboard"></el-switch>
        </el-form-item>
        <el-form-item label="Spotlight" ref="spotlight" prop="spotlight" v-if="creator || company_user">
          <el-switch v-model="user.spotlight"></el-switch>
        </el-form-item>
        <el-form-item
          label="First name"
          ref="first_name"
          prop="first_name"
          :rules="[{ required: true, message: 'first name is required' }]"
        >
          <el-input type="text" v-model="user.first_name" clearable />
        </el-form-item>
        <el-form-item
          label="Last name"
          ref="surname"
          prop="surname"
          :rules="[{ required: true, message: 'last name is required' }]"
        >
          <el-input type="text" v-model="user.surname" clearable />
        </el-form-item>
        <el-form-item
          v-if="creator || company_user"
          label="Creator name"
          ref="name"
          prop="name"
        >
          <el-input type="text" v-model="user.name" clearable />
        </el-form-item>
        <el-form-item
          v-if="creator || company_user"
          label="Biography"
          ref="biography"
          prop="biography"
        >
          <el-input type="text" v-model="user.biography" clearable />
        </el-form-item>

        <el-form-item
          v-if="creator || company_user"
          label="Quote"
          ref="quote"
          prop="quote"
        >
          <el-input type="text" v-model="user.quote" clearable />
        </el-form-item>

        <el-form-item
          v-if="creator || company_user"
          label="Phone number"
          ref="phone"
          prop="phone"
        >
          <el-input type="text" v-model="user.phone" clearable />
        </el-form-item>
        <el-form-item
          v-if="creator || company_user"
          label="Address"
          ref="address"
          prop="address"
        >
          <el-input type="text" v-model="user.address" clearable />
        </el-form-item>
        <el-form-item
          v-if="creator || company_user"
          label="Date of birth"
          ref="birthday"
          prop="birthday"
        >
          <el-input type="date" v-model="user.birthday" clearable />
        </el-form-item>
        <el-form-item
          label="Country"
          prop="country_of_residence"
          ref="country"
          :rules="[{ required: true, message: 'country is required' }]"
        >
          <el-select
            v-model="user.country_of_residence"
            clearable
            filterable
            class="mr10"
          >
            <el-option
              v-for="a in countries"
              :key="a.iso"
              :value="a.iso"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="user-type-wrap">
        <el-form-item label="User type" prop="user_level">
          <el-select
            v-model="user.user_level"
            @change="change"
            clearable
            filterable
            class="mr10 capitalize"
          >
            <el-option value="sysadmin" label="Admin"></el-option>
            <el-option value="artist_admin" label="Artist Admin"></el-option>
            <el-option value="label_admin" label="Label Admin"></el-option>
            <el-option value="company_user" label="Company User"></el-option>
            <el-option value="company_admin" label="Company Admin"></el-option>
            <el-option value="user" label="Creator User"></el-option>
            <el-option value="creator" label="Verified Creator"></el-option>
          </el-select>
        </el-form-item>
          <el-checkbox v-if="user.user_level === 'company_admin'" class="ml10 mb8" v-model="shareWithMcn"
                       label="Share With" border></el-checkbox>
        </div>
        <el-form-item
          label="Label"
          prop="label"
          v-show="label_admin"
          ref="label"
          :rules="[{ required: true, message: 'Label is required' }]"
          :error="validation['label']"
        >
          <el-select
            v-model="user.label"
            clearable
            filterable
            class="mr10"
            @change="changeLabel"
          >
            <el-option
              v-for="a in labels"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
          <el-tooltip content="Add new label" placement="top">
            <el-button
              icon="el-icon-plus"
              type="success"
              circle
              @click="insertLabel"
            ></el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item
          label="Artist"
          prop="artist"
          v-show="artist_admin"
          ref="artist"
          :rules="[{ required: true, message: 'Artist is required' }]"
          :error="validation['artist']"
        >
          <el-select
            v-model="user.artist"
            clearable
            filterable
            class="mr10"
            @change="changeArtist"
          >
            <el-option
              v-for="a in artists"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
          <el-tooltip content="Add new artist" placement="top">
            <el-button
              icon="el-icon-plus"
              type="success"
              circle
              @click="openArtist"
            ></el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item
          label="Company Admin"
          prop="company_admin"
          v-show="company_user || (user.user_level === 'company_admin' && shareCompanyAdmin)"
          ref="company_admin"
          :rules="[{ required: true, message: 'Company Admin is required' }]"
          :error="validation['company_admin']"
        >
          <el-select
            v-model="user.company_admin"
            clearable
            filterable
            class="mr10"
            @change="changeCompany"
          >
            <el-option
              v-for="a in companyAdmins"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="User level" prop="user_tier">
          <el-select
            v-model="user.user_tier"
            @change="change"
            clearable
            filterable
            class="mr10 capitalize"
          >
            <el-option
              v-for="t in tiers"
              :key="t.value"
              :value="t.value"
              :label="t.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Permission" prop="permission" v-if="sysadmin">
          <el-select
            v-model="user.permission"
            @change="change"
            clearable
            filterable
            class="mr10 capitalize"
          >
            <el-option
              v-for="t in permissions"
              :key="t.value"
              :value="t.value"
              :label="t.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <div v-if="showWallet" class="wallet-input">
          <el-form-item label="User Wallet($)" ref="user_wallet" prop="wallet">
            <el-input
              class="d-ib"
              type="text"
              v-model.number="wallet"
              clearable
            />
          </el-form-item>
          <el-tooltip class="item" effect="dark" content="Add Note" placement="top">
          <el-button icon="el-icon-plus" @click="addNote" circle></el-button>
          </el-tooltip>
        </div>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <DialogArtist />
    <DialogLabel />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import DialogArtist from '../../track-import/components/DialogArtist'
import DialogLabel from '../../new-releases/components/DialogLabel'
import { Message } from '@/plugins/element-ui'

export default {
  data() {
    return {
      image: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      },
      adminUrl: process.env.VUE_APP_ADMIN_API_URL,
      oldWallet: 0
    }
  },

  props: {
    activeTab: { type: String, required: true }
  },

  components: {
    DialogArtist,
    DialogLabel
  },
  watch: {
    dialog_artist: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.getArtist()
      }
    },
    dialog_label: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.getLabel()
      }
    }
  },
  computed: {
    ...mapState('user', [
      'loading',
      'user',
      'artists',
      'companyAdmins',
      'labels',
      'dialog',
      'countries',
      'validation',
      'showWallet',
      'shareCompanyAdmin'
    ]),
    ...mapState('trackImport', ['dialog_artist']),
    ...mapState('newReleasesLabels', { dialog_label: 'dialog' }),
    ...mapGetters('user', ['isUserWallet', 'isLabelWallet']),
    wallet: {
      get() {
        return this.$store.state.user.user.wallet
      },
      set(val) {
        this.$store.commit('user/setWallet', val)
      }
    },
    shareWithMcn: {
      get() {
        return this.$store.state.user.shareCompanyAdmin
      },
      set(value) {
        this.$store.commit('user/setShareCompanyAdmin', value)
      }
    },
    dialogTitle: function() {
      if (this.user.id !== null) {
        return 'Edit User'
      } else {
        return 'Insert User'
      }
    },
    artist_admin: function() {
      if (this.user.user_level == 'artist_admin') return true
      else {
        return false
      }
    },
    label_admin: function() {
      if (this.user.user_level == 'label_admin') return true
      else {
        return false
      }
    },
    company_user: function() {
      if (this.user.user_level == 'company_user') return true
      else {
        return false
      }
    },
    creator: function() {
      if (this.user.user_level == 'creator') return true
      else {
        return false
      }
    },
    sysadmin: function() {
      if (this.user.user_level == 'sysadmin') return true
      else {
        return false
      }
    },
    userlevel: function() {
      if (this.user.user_level == 'user') return true
      else {
        return false
      }
    },
  },

  methods: {
    ...mapActions('user', [
      'update',
      'insert',
      'getArtist',
      'getLabel',
      'getCountry',
      'deleteImage',
      'read'
    ]),
    ...mapActions('artistUsers', ['readArtistUsers']),
    ...mapActions('labelUsers', ['readLabelUsers']),
    ...mapActions('creatorUsers', ['readCreatorUsers']),
    ...mapActions('mcnUsers', ['readMcnUsers']),
    ...mapActions('permissionUsers', ['readPermissionUsers']),
    ...mapMutations('user', [
      'setDialog',
      'setValidation',
      'setLoading',
      'setSelectedUser',
      'setImage'
    ]),
    ...mapMutations('trackImport', ['setDialogArtist']),
    ...mapMutations('newReleasesLabels', { setLabelDialog: 'setDialog' }),
    ...mapMutations('user', ['setShareCompanyAdmin', 'setAmountDescription']),

    handleAvatarSuccess(res) {
      this.setImage(res.path)
      this.read()
      this.readData()
      this.$message({
        message: 'Image successfully uploaded.',
        type: 'success'
      })
    },

    handleAvatarError() {
      this.$message({
        type: 'error',
        message: 'Image upload failed'
      })
    },

    deleteCreatorImage(event) {
      event.stopPropagation()
      this.deleteImage().then(() => {
        this.readData()
      })
    },

    submit() {
      if (this.user.id !== null) {
        this.setLoading(true)
        this.update(this.oldWallet).then(() => {
          this.readData()
        })
      } else {
        this.insert()
      }
    },

    change() {
      this.user.artist = null
      this.user.label = null
    },

    resetValidation(formName) {
      if (typeof this.$refs[formName] != 'undefined') {
        this.$refs[formName].fields.find(f => f.prop == 'email').clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'first_name')
          .clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'surname')
          .clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'country_of_residence')
          .clearValidate()
        this.$refs[formName].fields.find(f => f.prop == 'label').clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'artist')
          .clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'company_admin')
          .clearValidate()
      }
    },

    changeArtist() {
      this.validation['artist'] = null
      this.$refs['user'].fields.find(f => f.prop == 'artist').clearValidate()
    },

    changeLabel() {
      this.validation['label'] = null
      this.$refs['user'].fields.find(f => f.prop == 'label').clearValidate()
    },

    changeCompany() {
      this.validation['company_admin'] = null
      this.$refs['company_admin'].fields
        .find(f => f.prop == 'company_admin')
        .clearValidate()
    },

    close() {
      this.setDialog(false)
      this.setSelectedUser({})
      this.setShareCompanyAdmin(false)
    },

    open() {
      if(this.user.wallet !== null){
        this.oldWallet = this.user.wallet
      } else {
        this.oldWallet = 0;
      }
      if (this.user.id == null) {
        setTimeout(() => {
          this.$refs['user'].clearValidate()
        }, 5)
      }
      if (this.user.user_level === 'company_admin' && this.user.company_admin) {
        this.setShareCompanyAdmin(true)
      }
    },
    openArtist() {
      this.setDialogArtist({ status: true, type: 'Create', id: null })
    },
    insertLabel() {
      this.setLabelDialog(true)
    },

    readData() {
      this.readArtistUsers()
      this.readLabelUsers()
      this.readCreatorUsers()
      this.readMcnUsers()
      this.readPermissionUsers()
    },

    addNote() {
      this.$prompt('Please fill description for amount', 'Note', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputValue: this.user.amountDescriptioni
      })
        .then(({ value }) => {
          this.setAmountDescription(value)
      })
        .catch(() => {
          this.setAmountDescription(null)
        })
    }
  },

  created() {
    this.getLabel()
    this.getArtist()
    this.getCountry()
  }
}
</script>

<style lang="scss">
.avatar-uploader {
  text-align: center;
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: 178px;
    height: 178px;
  }
  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-delete-icon {
    position: absolute;
    top: -6px;
    right: -6px;
    z-index: 100;
    font-size: 25px;
    color: #d40c41;;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.user-avatar {
  width: 178px;
  height: 178px;
  display: block;
  border-radius: 6px;
  margin: 0;
}

.user-type-wrap {
  display: flex;
  align-items: flex-end;

  .el-checkbox {
    border-radius: 10px;
  }
  .el-checkbox.is-bordered.is-checked,
  .el-checkbox__input.is-focus,
  .el-checkbox__inner {
    border-color: #868292 !important;
  }

  .el-checkbox__inner:hover {
    border-color: #868292;
  }
  .error-message {
    margin: 0;
    font-size: 12px;
    color: #d40c41;
  }
}
.wallet-input {
  display: flex;
  align-items: flex-end;
  button {
    margin: 0.5rem;
  }
}

.social-networks {
  margin: 20px 0 10px;
  text-align: center;

  &__list {

    &--item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;

      &:not(:first-child) {
        margin-top: 20px;
      }
    }
    &--item-options {
      text-align: center;
      width: 216px;
      i {
        color: #605677;;
      }
    }
    &--item-title {
      display: flex;
      align-items: center;
      margin-right: 20px;
      font-weight: 600;
      width: 100px;
      cursor: pointer;

      img {
        margin-right: 5px;

        &.youtube {
          width: 23px;
          height: 16px;
          margin-left: -3px;
          margin-right: 1px;
        }
        &.instagram,  &.tiktok {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>
